module.exports = __webpack_public_path__ + "img/icon-banner-dex-mobile.d045a521.svg";